<!-- product name -->
<div class="w-12 m-t-4-s m-t-4-m">
    <h1 class="w-11">
        @if (product?.displayBrandCode) {
        <span class="block s1 w-11 col-11">{{asString(product.brandCode) | titlecase}}&nbsp;</span>
        }
        @if (product?.displayRangeCode) {
        <span class="block s1">{{asString(product.rangeCode) | titlecase}}&nbsp;</span>
        }
        @if (product?.data?.product_outline || productView.parent?.data?.product_outline) {
        <span class="block p1">{{product.data.product_outline
            || productView.parent.data.product_outline}}&nbsp;</span>
        }
        @if (product?.data?.parent && product?.data?.variant_attribute_1) {
        <span class="ng-hide">,
            {{variantAttribute1}}</span>
        }
        @if (!product?.data?.parent && product?.data?.web_finish) {
        <span class="ng-hide">,&nbsp;{{product.data.web_finish}}</span>
        }
    </h1>
    <product-view-wishlist-toggle class="w-1 right"
                                  [productId]="product?.id" />
</div>

<!-- product price -->
<div class="m-b-8 m-b-5-s flex flex-justify-between flex-top flex-middle-s">
    <product-view-price class="m-t block"
                        [product]="product" />
    <ng-container>
        @if (product?.canDisplayReviews) {
        <div class="pos-relative">
            <reviews-io-rating class="m-t-3 block"
                               [product]="product" />
            <div class="fill z-1 cursor-pointer"
                 scrollTo="#reviews"></div>
        </div>
        }
    </ng-container>
</div>

<!-- if product is clearance -->
@if (isClearanceView && store) {
<see-range-in-store-product-status class="m-t-7 m-b-7 block"
                                   [store]="store" />
}

@if (!product?.parent.isConfigurable && !displayColorCrossSells) {
<div class="flex flex-justify-between m-b-6">
    <div>
        <span class="s2">{{'Colour' | translate }}: </span>
        <span class="p2">
            @if (product.data.parent && product.data.variant_attribute_1) {
            {{product.variantAttribute1}}
            }
            @if (!product.data.parent && product.data.web_finish) {
            {{product.data.web_finish}}
            }</span>
    </div>
    @if (!client.isS) {
    <product-view-samples class="block"
                          [product]="product" />
    }
</div>
}

<!-- configurable options -->
@if (product?.parent?.isConfigurable) {
<product-view-configurable-options class="m-t block"
                                   [storage]="true"
                                   [product]="product"
                                   id="pdpConfigurableOptions"
                                   [preselectSingles]="true"
                                   (selectionChange)="productView.matchExactly($event.data)"
                                   (init)="onProductConfigurablesInit($event)">
</product-view-configurable-options>
}

@if (displayColorCrossSells) {
<product-view-crosssell-products-color class="block m-t"
                                       [product]="product"
                                       [ngClass]="{'m-b m-b-0-s' : product?.familySamples?.length}" />
}
@if(product?.familySamples?.length){
<div class="w-12 p-t-4 p-t-0-s"></div>
@if (client.isS) {
<product-view-samples class="block m-b-6"
                      [product]="product" />
}

}
@if (product?.canShowMoreColourOptionsAvailableInfo) {
<div class="text m-t m-t-1-s c1 col-12"
     *iCms="'moreColoursCopy' of content; content: 'html'; skipEmpty: true"></div>
}

@if (product?.hasSizeCrosssells) {
<product-view-crosssell-products-size class="block"
                                      [ngClass]="{'m-t' : !product.parent.isConfigurable}"
                                      [product]="product" />
}

<product-view-upsell-products class="block"
                              [source]="product"
                              [options]="{ engines: 'upsell', normalize: false, nonRoutable: true }"
                              [content]="content" />

@if (isClearanceView) {
<product-view-specification-icms class="m-t-7 block"
                                 [product]="product"
                                 [attributes]="specSections" />
}

<div class="m-t-8 m-t-6-s">
    <ng-container *ngTemplateOutlet="trustMessages" />
</div>

<!-- promo banner -->
@if (product?.data?.promotion_banner | optionImage : 'promotion_banner') {
<div class="w-12 m-b center m-t-8 m-t-7-s">
    <div class="ratio-7-1">
        <img class="rf"
             [image]="product.data.promotion_banner | optionImage : 'promotion_banner'"
             [alt]="'Promotion Banner'">
    </div>
</div>
}

@if((client.isX || client.isL) && product?.isFinanceAllowed){
<!-- v12 -->
<v12-retail-finance-from [amount]="product.financeAmount"
                         [isDiningChair]="product.isDiningChairFinanceAllowed" />
}

@if(!client.isS){
<div [ngClass]="{'m-t-8' : !(product.data.promotion_banner | optionImage : 'promotion_banner')}">
    <ng-container *ngTemplateOutlet="a2bButton" />
</div>
} @else {
<bottom-panel [bottomPanelRestricted]="['footer']">
    <ng-container *ngTemplateOutlet="a2bButton" />
</bottom-panel>
}

@if((client.isS || client.isM) && product?.isFinanceAllowed){
<v12-retail-finance-from class="block m-b"
                         [amount]="product.financeAmount"
                         [isDiningChair]="product.isDiningChairFinanceAllowed" />
}

<product-view-specification class="block m-t-4-x m-t-4-l"
                            [product]="product"
                            [attributes]="specificationAttributesCodes" />

<ng-template #trustMessages>
    <!-- stock levels  -->
    @if (!product.isConfigurable && product.isSalable()) {
    <product-stock-levels [qty]="selectedQty"
                          [product]="product" />
    }
    @if (!product.isConfigurable && product.isSalable()) {
    <product-info-delivery class="block"
                           [qty]="selectedQty"
                           [buyRequest]="productView.request"
                           [product]="product" />
    }

    @if (product.data.warranty_years) {
    <product-warranty class="block"
                      [copy]="product.data.warranty_years" />
    }

    @if (product.data.trust_message1) {
    <pdp-trust-messages class="block"
                        [variant]="product.data.trust_message1" />
    }

    @if (product.data.trust_message2) {
    <pdp-trust-messages class="block"
                        [variant]="product.data.trust_message2" />
    }

    @if (product.data.trust_message3) {
    <pdp-trust-messages class="block"
                        [variant]="product.data.trust_message3" />
    }
    <product-view-tree class="block"
                       [product]="product" />
</ng-template>


<ng-template #a2bButton>
    <div class="flex">
        @switch (!!isClearanceView) {
        @case (true) {
        @switch (!!isClearanceSold) {
        @case (true) {
        <button type="button"
                class="button w-12 is-disabled">{{'Sold' | translate}}</button>
        }
        @default {
        @if (store) {
        <a [routerLink]="store.data.url"
           class="button w-12">{{'Enquire about this product' | translate}}</a>
        }
        }
        }
        }
        @default {
        @if (product.displayQtySelector) {
        <basket-item-qty [(model)]="selectedQty"
                         [max]="9999"
                         [product]="product"
                         class="inline-block qty-button m-r-2"
                         (modelChange)="detectChanges()" />
        }
        <product-view-add-to-basket class="flex-grow"
                                    [product]="product"
                                    [buyRequest]="productView.request"
                                    [qty]="selectedQty"
                                    cy-ppAddToBasketButton />
        }
        }
    </div>
</ng-template>
